import React from 'react'
const Address = () => {
    return (
        <div className='address'>
            <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3038.4905440049583!2d49.85618949070231!3d40.39798248315686!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40307d43cfb572bf%3A0xd77063dd317bb0b3!2sButa%20Clinic!5e0!3m2!1str!2saz!4v1736244577885!5m2!1str!2saz"
                height="300px"
                id="address"
                width="100%"
                allowFullScreen={true}
                style={{border: 'none'}}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade" />

                
        </div>
    )
}

export default Address

